var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_5045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2663 13.1747C24.2663 12.359 24.2001 11.5388 24.059 10.7363H12.7402V15.3573H19.222C18.953 16.8477 18.0888 18.1661 16.8233 19.0038V22.0022H20.6903C22.9611 19.9121 24.2663 16.8256 24.2663 13.1747Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7401 24.8993C15.9766 24.8993 18.7059 23.8366 20.6945 22.0023L16.8276 19.004C15.7517 19.7359 14.3627 20.1504 12.7445 20.1504C9.61388 20.1504 6.95946 18.0383 6.00705 15.1987H2.0166V18.2897C4.05371 22.3418 8.2029 24.8993 12.7401 24.8993Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00277 15.1986C5.50011 13.7083 5.50011 12.0945 6.00277 10.6041V7.51318H2.01674C0.314734 10.904 0.314734 14.8988 2.01674 18.2896L6.00277 15.1986Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7401 5.6481C14.4509 5.62164 16.1044 6.2654 17.3434 7.44711L20.7695 4.02105C18.6001 1.98394 15.7208 0.863972 12.7401 0.899246C8.2029 0.899246 4.05371 3.45666 2.0166 7.51325L6.00264 10.6042C6.95064 7.76017 9.60947 5.6481 12.7401 5.6481Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_5045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.898438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.18900e6e7b919d2a567ac278923a9b7e.svg";
export { ForwardRef as ReactComponent };